// Re-exported with webpack or browserify syntax so that development tools are discarded in production
// builds. ES6 import statements can not be preceded by logic.
if (process.env.NODE_ENV === "production") {
    module.exports = require("./configureStore.prod.js");
} else {
    module.exports = require("./configureStore.dev.js");
}